import { Button, Modal } from "react-bootstrap";
import { FaTimes } from "react-icons/fa";

const PresentMemberModel = ({ setShowModal, showModal, memberDetail }) => {
  return (
    <>
      <Modal show={showModal} onHide={() => setShowModal(false)} scrollable>
        <Modal.Header className="d-flex justify-content-between align-items-center">
          <Modal.Title>Member Details</Modal.Title>
          <button
            type="button"
            className="close"
            onClick={() => setShowModal(false)}
            aria-label="Close"
            style={{
              border: "none",
              background: "transparent",
              cursor: "pointer",
            }}
          >
            <FaTimes size={24} />
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="details-section">
            {/* <h6>व्यक्ति का विवरण</h6> */}
            <div className="row">
              <div className="col-md-3">
                <div className="present-member-img">
                  <img
                    src={memberDetail.image}
                    alt={memberDetail.name}
                    className="img-fluid"
                    // style={{ maxWidth: "100%", height: "auto" }}
                  />

                  <h4>{memberDetail.name}</h4>
                  <h5>{memberDetail.designation}</h5>
                </div>
              </div>
              <div className="col-md-9">
                <div
                  dangerouslySetInnerHTML={{
                    __html: memberDetail?.description,
                  }}
                ></div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PresentMemberModel;
